import React, { useMemo } from "react";
import { Accordion } from "Components/Base/Surfaces/Accordion";
import { useLearningCatalogue } from "../../context";
import FilterMobileSummary from "./FilterMobileSummary";
import FilterMobileDetails from "./FilterMobileDetails";

const FilterMobile = ({ languageContext }) => {
  const { state, setCategoriesValue, updateFilters, resetFilters } =
    useLearningCatalogue();

  const {
    otherCategories,
    categoriesValue,
    startDate,
    endDate,
    sessionRegion,
    sessionCity,
    learningActivities,
    hasActiveFilters,
    allUniqueRegions: stateUniqueRegions,
    allUniqueCities: stateUniqueCities,
  } = state;

  const handleChange = (event, categoryName, value) => {
    const toArray = (val) => {
      if (Array.isArray(val)) return val;
      if (val === 0 || val === null || val === undefined || val === "")
        return [];
      return [val];
    };
    const updatedCategoriesValue = {
      ...categoriesValue,
      [categoryName]: toArray(value),
    };
    setCategoriesValue(updatedCategoriesValue);
  };

  const handleDateChange = (event, name, value) => {
    updateFilters({ [name]: value });
  };

  const handleSessionChange = (event, name, value) => {
    const toArray = (val) => {
      if (Array.isArray(val)) return val;
      if (val === 0 || val === null || val === undefined || val === "")
        return [];
      return [val];
    };
    updateFilters({ [name]: toArray(value) });
  };

  // Use full-catalogue region/city lists so Område and Ort stay visible when category filters are applied
  const { uniqueRegions, uniqueCities } = useMemo(() => {
    if (Array.isArray(stateUniqueRegions) && Array.isArray(stateUniqueCities)) {
      return {
        uniqueRegions: stateUniqueRegions,
        uniqueCities: stateUniqueCities,
      };
    }
    if (!learningActivities?.courses) {
      return { uniqueRegions: [], uniqueCities: [] };
    }
    const regions = new Set();
    const cities = new Set();
    learningActivities.courses.forEach((course) => {
      if (course.sessions && Array.isArray(course.sessions)) {
        course.sessions.forEach((session) => {
          if (session.region) regions.add(session.region);
          if (session.city) cities.add(session.city);
        });
      }
    });
    return {
      uniqueRegions: Array.from(regions).sort(),
      uniqueCities: Array.from(cities).sort(),
    };
  }, [stateUniqueRegions, stateUniqueCities, learningActivities]);

  const hitCount = learningActivities?.totalAmountOfCourses || 0;

  const handleReset = async () => {
    await resetFilters();
  };

  return (
    <Accordion
      id="learningCatalogue-filter-mobile"
      summaryText={
        <FilterMobileSummary
          languageContext={languageContext}
          hasActiveFilters={hasActiveFilters}
          hitCount={hitCount}
        />
      }
      detailsText={
        <FilterMobileDetails
          languageContext={languageContext}
          hasActiveFilters={hasActiveFilters}
          resetFilters={handleReset}
          startDate={startDate}
          endDate={endDate}
          handleDateChange={handleDateChange}
          uniqueRegions={uniqueRegions}
          uniqueCities={uniqueCities}
          sessionRegion={sessionRegion}
          sessionCity={sessionCity}
          handleSessionChange={handleSessionChange}
          otherCategories={otherCategories}
          categoriesValue={categoriesValue}
          handleChange={handleChange}
        />
      }
      defaultExpanded={hasActiveFilters}
      disableGutters={false}
      border={true}
      boxShadow={false}
      square
      slotProps={{
        root: {
          sx: {
            borderRadius: "2px !important",
          },
        },
        details: {
          sx: {
            padding: "8px 12px 12px !important",
          },
        },
      }}
    />
  );
};

export default FilterMobile;
